import parse from "../utils/xml-parsers/identities";
import { getApiUrl } from "../utils/get-api-url";

import type { IxDirectoryUser } from "./types/User";

export const getUsers = async ({
  alc
}: {
  alc: string;
}): Promise<IxDirectoryUser> => {
  const apiUrl = getApiUrl("ixdirectory");
  const fullUrl = `${apiUrl}/identities/?AgentsOfLocation=${alc}&mode=extended`;
  const response = await fetch(fullUrl, {
    method: "GET",
    credentials: "include",
    headers: {
      accept: "application/xml"
    }
  });
  const { statusText, ok } = response;
  const xml = await response.text();
  if (!ok) throw new Error(statusText);
  return parse(xml);
};
